var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlogIcon02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.804 6.97708L15.222 13.9825C15.2361 14.1737 15.144 14.3013 15.0945 14.3579C15.0378 14.4217 14.9174 14.5208 14.719 14.5208H12.7853L14.3153 6.97708H14.804ZM15.5832 4.25L15.5761 4.26417C15.5903 4.43417 15.5761 4.61125 15.5336 4.78833L10.3132 14.3721C10.1432 15.0875 9.50571 15.5833 8.76904 15.5833H14.719C15.6328 15.5833 16.3553 14.8113 16.2845 13.8975L15.5832 4.25Z",
    fill: "url(#paint0_linear_743_2894)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11026 1.58666C8.18109 1.30332 8.00401 1.01291 7.72067 0.942073C7.43734 0.878323 7.14692 1.04832 7.07609 1.33166L6.72192 2.79791H7.81276L8.11026 1.58666Z",
    fill: "url(#paint1_linear_743_2894)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7853 1.56539C12.849 1.27498 12.6649 0.998727 12.3745 0.934977C12.0911 0.871227 11.8078 1.05539 11.744 1.34581L11.4253 2.81206H12.5161L12.7853 1.56539Z",
    fill: "url(#paint2_linear_743_2894)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4556 3.7756C15.2218 3.20893 14.6693 2.80518 13.9893 2.80518H12.516L12.1193 4.63977C12.0627 4.88768 11.8431 5.05768 11.6022 5.05768C11.5668 5.05768 11.5243 5.05768 11.4889 5.04352C11.2056 4.97977 11.0214 4.69643 11.0781 4.4131L11.4252 2.7981H7.81266L7.36641 4.63977C7.30974 4.8806 7.09016 5.04352 6.84933 5.04352C6.80683 5.04352 6.76433 5.03643 6.72183 5.02935C6.43849 4.95852 6.26141 4.67518 6.33224 4.38477L6.71474 2.79102H5.27683C4.58266 2.79102 3.96641 3.24435 3.76099 3.91018L0.778911 13.5081C0.467245 14.5352 1.22516 15.5835 2.29474 15.5835H11.6022C12.3389 15.5835 12.9764 15.0877 13.1464 14.3723L15.5335 4.78852C15.576 4.61143 15.5902 4.43435 15.576 4.26435C15.5618 4.09435 15.5264 3.92435 15.4556 3.7756ZM10.4122 11.8648H4.74558C4.45516 11.8648 4.21433 11.6239 4.21433 11.3335C4.21433 11.0431 4.45516 10.8023 4.74558 10.8023H10.4122C10.7027 10.8023 10.9435 11.0431 10.9435 11.3335C10.9435 11.6239 10.7027 11.8648 10.4122 11.8648ZM11.1206 9.03143H5.45391C5.16349 9.03143 4.92266 8.7906 4.92266 8.50018C4.92266 8.20977 5.16349 7.96893 5.45391 7.96893H11.1206C11.411 7.96893 11.6518 8.20977 11.6518 8.50018C11.6518 8.7906 11.411 9.03143 11.1206 9.03143Z",
    fill: "url(#paint3_linear_743_2894)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_743_2894",
    x1: 8.26056,
    y1: 13.6884,
    x2: 18.4552,
    y2: 8.42353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00A4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_743_2894",
    x1: 6.62699,
    y1: 2.48538,
    x2: 8.42382,
    y2: 1.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00A4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_743_2894",
    x1: 11.3325,
    y1: 2.4961,
    x2: 13.1187,
    y2: 1.48633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00A4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_743_2894",
    x1: -0.297404,
    y1: 13.4446,
    x2: 13.7448,
    y2: 0.738231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00A4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF97"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogIcon02);
export default __webpack_public_path__ + "static/media/blog-icon02.31774660a147c62afdc0af42b0ad1fb1.svg";
export { ForwardRef as ReactComponent };